import { yup } from 'common/validation/initYup';

/** Validazione per passare allo stato "In Verifica" */
export const taxRecordToVerifySchema = yup.object({}).required().noUnknown();

/** Validazione per passare agli stati successivi alla verifica della scheda anagrafica */
export const taxRecordEvaluatedSchema = yup.object({}).required().noUnknown();
